// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"63f58af8","453":"0c626c0a","469":"15c858df","470":"6a3cbf59","598":"6dde1a06","787":"bb20b309","886":"20de81a3"}[chunkId] + ".chunk.js";
};